'use client';

import { useState, useEffect, useRef } from 'react';
import Link from "next/link";
import { FiLogIn, FiUser, FiUsers } from "react-icons/fi";
import { FaChevronDown } from "react-icons/fa";

import Image from 'next/image';

// Receive 'align' as a prop. Default to 'left' for safety.
export default function UserLoginSheet({ align = "left", textColor = "text-gray-900", width = 22, height = 22, size }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const imgWidth = width || size || 22;
  const imgHeight = height || size || 22;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const loginOptions = [
    {
      label: "ورود مشتریان",
      href: "https://sale.barsavosh.co/Subscriber/Login",
      icon: <FiUsers className="text-blue-600" />,
      external: true,
    },
    {
      label: "ورود پرسنل",
      href: "/staffLogin",
      icon: <FiUser className="text-slate-700" />,
      external: false,
    },
  ];

  return (
    <div className="relative inline-block text-right" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        className={`flex items-center justify-center w-10 h-10 transition-colors hover:text-gray-500 ${textColor}`}
        aria-label="ورود"
      >
        <Image
          src="/userIcon.png"
          alt="User"
          width={imgWidth}
          height={imgHeight}
          className={textColor.includes("white") ? "brightness-0 invert" : "brightness-0"}
        />
      </button>

      {isOpen && (
        <div className={`
          absolute mt-2 w-48 
          bg-white border border-gray-200 shadow-xl 
          z-[10000] overflow-hidden animate-in fade-in zoom-in duration-150
          ${align === "right" ? "right-0" : "left-0"}
        `}>
          <div className="py-1 flex flex-col">
            {loginOptions.map((option, index) => (
              <Link
                key={index}
                href={option.href}
                target={option.external ? "_blank" : "_self"}
                onClick={() => setIsOpen(false)}
                className="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors border-b last:border-b-0 border-gray-50"
              >
                <span className="text-lg">{option.icon}</span>
                <span className="font-medium">{option.label}</span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}